import VehicleDetails from "./VehicleDetails";

export default VehicleDetails;
